<p [ngClass]="{ 'app-version--collapsed': collapsed }" class="app-version">
  <span>Version</span>
  <span [ngClass]="{ 'app-version__num--no-margin': collapsed }" class="app-version__num">{{ appVersion }}</span>
</p>
